export enum Role {
  Administrator = 'administrator',
  Planner = 'planner',
  RidePlanner = 'rideplanner',
  Driver = 'driver',
  CoDriver = 'co_driver',
  Other = 'other',
}

export enum PaymentMethod {
  NONE = 'none',
  SEPA = 'sepa',
  MOLLIE = 'mollie',
}

export enum FilterOption {
  NoCard = 'noCard',
  HasCard = 'hasCard',
  NoPlan = 'noPlan',
  HasPlan = 'hasPlan',
  WarningLowCredits = 'lowCredits',
  WarningPaymentError = 'paymentError',
  WarningSendSepaMandate = 'sendSepaMandate',
  WarningUploadSepaMandate = 'uploadSepaMandate',
  Name = 'name',
  Email = 'email',
  Address = 'address',
  PhoneNumber = 'phoneNumber',
  PaymentMethodMollie = 'paymentMethodMollie',
  PaymentMethodSepa = 'paymentMethodSepa',
}

export enum NotificationType {
  Reminder = 'reminder',
}

export enum PlanType {
  Rides = 'rides',
  Drivers = 'drivers',
  Planners = 'planners',
  Automatic = 'automatic',
}

export enum LogType {
  AutomaticPlanningStarted = 'automaticPlanningStarted',
  AutomaticPlanningReset = 'automaticPlanningReset',
  RidePreparationVehicle = 'ridePreparationVehicle',
  RidePreparationVehicleGroup = 'ridePreparationVehicleGroup',
  RidePreparationRate = 'ridePreparationRate',
  RidePreparationCharacteristic = 'ridePreparationCharacteristic',
  RidePreparationStandardLocation = 'ridePreparationStandardLocation',
  RidePreparationPhoneNumber = 'ridePreparationPhoneNumber',
  RidePreparationParticularity = 'ridePreparationParticularity',
}
